interface HoneypotFieldProps {
  value: string;
  onChange: (v: string) => void;
}

/**
 * Anti-bot honeypot. A real-looking field that humans never see or tab to, but
 * bots auto-fill. It is sent in the payload (`companyWebsite`); the server drops
 * any submission where it's non-empty. Hidden via off-screen positioning (NOT
 * display:none, which some bots skip) + aria-hidden + tabIndex -1 + autocomplete off.
 */
export function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      <label htmlFor="company_website">Company website</label>
      <input
        id="company_website"
        name="company_website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
